function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8279 0.863025L7.23613 7.45794C7.0893 7.60477 6.85187 7.60477 6.70504 7.45794L0.113248 0.863025C-0.0335838 0.716193 -0.0335838 0.478764 0.113248 0.331933L0.335057 0.110124C0.481888 -0.0367078 0.719317 -0.0367078 0.866149 0.110124L6.97058 6.21768L13.0781 0.113248C13.225 -0.0335838 13.4624 -0.0335838 13.6092 0.113248L13.831 0.335057C13.9748 0.478764 13.9748 0.716193 13.8279 0.863025ZM13.8279 4.33074L13.6061 4.10893C13.4593 3.9621 13.2219 3.9621 13.075 4.10893L6.97058 10.2165L0.863025 4.11206C0.716193 3.96523 0.478764 3.96523 0.331933 4.11206L0.110124 4.33387C-0.0367078 4.4807 -0.0367078 4.71813 0.110124 4.86496L6.70191 11.4599C6.84875 11.6067 7.08618 11.6067 7.23301 11.4599L13.8248 4.86496C13.9748 4.71501 13.9748 4.47758 13.8279 4.33074Z",
  fill: "#838383"
});

function SvgExpand(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.7bac8ba7.svg";
export { ForwardRef as ReactComponent };